"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Input'
});

schema.makePropTypes = function () {
  return {
    disabled: _reactDesc.PropTypes.bool.description('Sets the input state to disabled if true.'),
    helpMessage: _reactDesc.PropTypes.string.description("A short message to help clarify the input's purpose to the user."),
    hideLabel: _reactDesc.PropTypes.bool.description("Visually hides the label, but leaves it available for screen readers. Use this only if you are sure the input doesn't need a visual label").defaultValue('false'),
    icon: _reactDesc.PropTypes.element.description('An icon to be rendered on the left side of the input.'),
    id: _reactDesc.PropTypes.string.description('A unique ID for the input.'),
    inputContainerRef: _reactDesc.PropTypes.oneOfType([// Either a function
    _reactDesc.PropTypes.func, // Or the instance of a DOM native element (current will be an instance of HTMLDivElement)
    _reactDesc.PropTypes.shape({
      current: _reactDesc.PropTypes.any
    })]).description('A reference to the container component for the input field.'),
    label: _reactDesc.PropTypes.string.description('A label for the input field.').isRequired,
    labelId: _reactDesc.PropTypes.string.description("A unique ID for the input's label. This will be used in some ARIA attributes as well."),
    maxLength: _reactDesc.PropTypes.number.description('The maximum number of characters allowed in the input field. No character limit if `undefined`.').defaultValue(undefined),
    onBlur: _reactDesc.PropTypes.func.description('A function for handling the blur event of the input.'),
    onChange: _reactDesc.PropTypes.func.description('A function for handling the change event of the input.'),
    onFocus: _reactDesc.PropTypes.func.description('A function for handling the focus event of the input.'),
    readOnly: _reactDesc.PropTypes.bool.description('Sets the input state to readonly if true.'),
    required: _reactDesc.PropTypes.bool.description('Sets the input state to required if true.'),
    requiredMessage: _reactDesc.PropTypes.string.description("Message to display in the required icon's Tooltip.").defaultValue('Required'),
    showCharacterCount: _reactDesc.PropTypes.bool.description('If true, and a `maxLength` is set, a message will be included in the help text indicating the count remaining characters in the input field').defaultValue(false),
    style: _reactDesc.PropTypes.object.description('A valid CSS style object, applied to the outermost container of the input'),
    value: _reactDesc.PropTypes.string.description('The value of the input. This must be controlled outside of this component.'),
    warningMessage: _reactDesc.PropTypes.string.description('A warning message for displaying some type of error with the input value.')
  };
};

schema.propTypes = schema.makePropTypes();
var _default = schema;
exports.default = _default;